import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { OrganizationOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { ORGANIZATION_DEFAULT_TAB, ORGANIZATION_SHOW_TABS } from '../constants';
import { OrganizationShowHeader } from './OrganizationShowHeader';
import { OrganizationGeneralTab } from './OrganizationGeneralTab';
import { OrganizationMembersTab } from './OrganizationMembersTab';
import { OrganizationPublishersTab } from './OrganizationPublishersTab';
import { OrganizationContractsTab } from './OrganizationContractsTab';

export const OrganizationShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<OrganizationOut>({
    resource: 'tenancy.organizations',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('tenancy.organizations', record?.name);

  const [activeTab, onTabChange] = useShowTab(
    ORGANIZATION_SHOW_TABS,
    ORGANIZATION_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <OrganizationShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <OrganizationGeneralTab record={record} />
            )}
            {activeTab === 'members' && (
              <OrganizationMembersTab
                record={record}
                onMembersChanged={() => query.refetch()}
              />
            )}
            {activeTab === 'publishers' && (
              <OrganizationPublishersTab record={record} />
            )}
            {activeTab === 'contracts' && (
              <OrganizationContractsTab record={record} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
